import { ICalendlyEvent } from 'api-paths-cas';
import { action } from 'typesafe-actions';
import { StudentActionTypes } from '../types';

export const getStudentCalendlyEvents = () => {
  return action(StudentActionTypes.GET_STUDENT_CALENDLY_EVENTS);
};

export const getStudentCalendlyEventsSuccess = (calendlyEvents: Record<string, ICalendlyEvent>) => {
  return action(StudentActionTypes.GET_STUDENT_CALENDLY_EVENTS_SUCCESS, {
    calendlyEvents,
  });
};

export const getStudentCalendlyEventsFailure = (error: string) => {
  return action(StudentActionTypes.GET_STUDENT_CALENDLY_EVENTS_FAILURE, {
    error,
  });
};

export const updateCalendlyEventWS = (payload: { calendlyEvents: Record<string, ICalendlyEvent> }) =>
  action(StudentActionTypes.UPDATE_CALENDLY_EVENT_WS, payload);
